module.exports = {
      id: "media-placeholder-usage",
      viewBox: "0 0 632 421",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#media-placeholder",
      toString: function () {
        return this.url;
      }
    }